import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FilterBar } from './components/FilterBar';
import { FeaturedGrid } from './components/FeaturedGrid';
import { HowItWorks } from './components/HowItWorks';
import { TrustSection } from './components/TrustSection';
import { AboutSection } from './components/AboutSection';
import { Footer } from './components/Footer';
function setMeta(name: string, content: string, property?: boolean) {
  const attr = property ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function App() {
  useEffect(() => {
    document.title = '新加坡是您网 IsYou - 新加坡领先的高端伴游服务平台 | 欧美日韩越南中国伴游女郎 | 真人核验 见面满意付款 | Singapore Premium Companion Service';
    document.documentElement.lang = 'zh-CN';
    // Basic SEO
    setMeta('description', '新加坡是您网 IsYou 是新加坡领先的高端伴游服务平台，汇集500+全球优质伴游女郎，提供欧美伴游、日本伴游、韩国伴游、越南伴游、中国伴游、泰国伴游等多国伴游服务。所有伴游女郎均经真人核验，三重认证确保真实可靠。独创见面满意付款模式，24/7在线客服，安全私密有保障。新加坡伴游首选IsYou是您网。Singapore premium companion escort service.');
    setMeta('keywords', '新加坡伴游,新加坡是您网,IsYou,是您网,新加坡伴游服务,高端伴游,伴游女郎,新加坡伴游女郎,欧美伴游,日本伴游,韩国伴游,越南伴游,中国伴游,泰国伴游,马来西亚伴游,混血伴游,商务伴游,旅行伴游,新加坡约会,真人核验伴游,安全伴游,见面付款,Singapore escort,Singapore companion,premium escort Singapore,Singapore companion service,geylang,新加坡高端陪伴,新加坡外围,新加坡模特伴游');
    setMeta('author', 'IsYou 是您网');
    setMeta('robots', 'index, follow');
    // Open Graph
    setMeta('og:title', '新加坡是您网 IsYou - 高端伴游服务平台 | 500+全球优质伴游女郎 | 真人核验', true);
    setMeta('og:description', '新加坡是您网IsYou汇集500+全球优质伴游女郎，提供欧美、日韩、越南、中国等多国高端伴游服务。真人核验，三重认证，见面满意后付款，24/7在线客服。新加坡伴游首选品牌。', true);
    setMeta('og:type', 'website', true);
    setMeta('og:url', 'https://geylang777-6.site/', true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('og:site_name', 'IsYou 是您网', true);
    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', '新加坡是您网 IsYou - 高端伴游服务平台 | 500+全球优质伴游女郎');
    setMeta('twitter:description', '新加坡是您网IsYou汇集500+全球优质伴游女郎，提供欧美、日韩、越南、中国等多国高端伴游服务。真人核验，见面满意后付款。');
  }, []);
  return <div className="min-h-screen bg-dark-900 text-white font-sans selection:bg-gold-500 selection:text-dark-900" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <FilterBar data-id="element-4" />
        <FeaturedGrid data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <TrustSection data-id="element-7" />
        <AboutSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}